import './styles.css';

export default function LoadingItem({ label, status }) {

  return (
    <div 
      className={`onboarding-loading-item ${status}`}
    >
      <span dangerouslySetInnerHTML={{ __html: label }}/>
    </div>
  );
}